import type { MetricKey } from '@contracts';
import { authedFetch } from '@/lib/apiClient';
import { BRIDGE_URL as BRIDGE } from '@/lib/config';

/** Membresía fuente→compañías (slugs) editada por el admin. Override de lo derivado de `sources`. */
export type SourceConfig = Partial<Record<MetricKey, string[]>>;

export async function fetchSourceConfig(): Promise<SourceConfig> {
  try {
    const res = await authedFetch(`${BRIDGE}/dashboards/source-config`);
    const body = await res.json();
    return (body?.success ? body.data : {}) as SourceConfig;
  } catch {
    return {};
  }
}

/** Guarda el mapa COMPLETO (solo admin; el BFF re-valida). `true` si ok. */
export async function saveSourceConfig(config: SourceConfig): Promise<boolean> {
  try {
    const res = await authedFetch(`${BRIDGE}/dashboards/source-config`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ config }),
    });
    const body = await res.json();
    return !!body?.success;
  } catch {
    return false;
  }
}
